// removed by extract-text-webpack-plugin
module.exports = {"nopermission_container":"_1yOSJ6n1W-o12XYyXOKlOA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NoPermission/NoPermission.scss
// module id = 2307
// module chunks = 0